import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import SegmentWrapper from './components/Wrapper';
import CreateRoute from './routes/Create';
import UpdateRoute from './routes/Update';

const CompanyQuery = gql`
query {
  Companies: userCompany {
    id
    name
    Jobs: job_openings {
      id
      title
      description
      job_time_status
      pay_class
      created_at
      updated_at
    }
  }
}
`;

const DeletePositionQuery = gql`
mutation($JobID: Int!) {
  deleteJobOpening(jobID: $JobID) {
    status
  }
}
`;

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default (store) => ({
  path : 'jobs',
  component: (props) => (
    <div className='container'>
      <div className='page-layout__viewport'>
        {props.children}
      </div>
    </div>
  ),
  indexRoute  : {
    component: connect(mapStateToProps)(
      compose(
        graphql(CompanyQuery, {
          name: 'CompanyData',
          options: {
            fetchPolicy: 'cache-and-network',
          },
        }),
        graphql(DeletePositionQuery, {
          name: 'deleteOpenPosition',
          options: (props) => ({
            skip: props.authenticatedID === null,
          }),
        }),
      )(SegmentWrapper))
  },
  childRoutes : [
    CreateRoute(store),
    UpdateRoute(store),
  ]
});



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/index.js